import { useEffect } from 'react';

import { selectReferenceBarUI } from '../redux/features/selectors/referenceBarUISelectors.ts';
import { useAppSelector } from '../redux/hooks.ts';
import {
  ALERT_TOAST_DATA_ATTR,
  COMPARABLES_ALERTS_TOAST_CLASS_NAME,
} from './useToaster/constants.ts';
import './useToaster/comparablesToast.scss';

const HOVER_SYNCED_CLASS_NAME = 'comparables-alerts-toast--hover-synced';

export const useAlertToastHoverEmphasis = () => {
  const { hoveredAlertType } = useAppSelector(selectReferenceBarUI);

  useEffect(() => {
    const toasterRoot = document.getElementById('_rht_toaster');
    if (!toasterRoot) {
      return;
    }

    toasterRoot.querySelectorAll(`.${COMPARABLES_ALERTS_TOAST_CLASS_NAME}`).forEach((toastEl) => {
      const alertType = toastEl
        .querySelector(`[${ALERT_TOAST_DATA_ATTR}]`)
        ?.getAttribute(ALERT_TOAST_DATA_ATTR);
      toastEl.classList.toggle(HOVER_SYNCED_CLASS_NAME, alertType === hoveredAlertType);
    });
  }, [hoveredAlertType]);
};
